import React from 'react';
import '../App.css';
import { FaCheck } from "react-icons/fa";
import mobilityImage from '../assets/nutrition.jpg';
import NutritionSwiper from '../components/NutritionSwiper';
import Stripes from '../components/Stripes';
import bg2 from "../assets/bg2.jpg"; 
import yogahall from "../assets/dance.jpg";
import Footer from '../components/Footer';
import Signup from '../components/Signup';
import VerticalSwiper2 from '../components/VerticalSwiper2';

const Nutrition = () => {
  return (
    <div className="mobility-page">
      {/* Hero Section */}
      <div
        className="mobility-banner"
        style={{ backgroundImage: `url(${mobilityImage})` }}
      >
        {/* Dark overlay */}
        <div className="banner-overlay"></div>

        <h2>NUTRITION</h2>
      </div>

     {/* Content Section */}
      <div className="mobility-content">
        <h3>What Is Nutrition Coaching?</h3>
        <p>
          Nutrition coaching is guidance around what, when, and how you eat to support your goals—whether that’s building strength, losing fat, improving energy, or simply feeling better in your body. It’s not about drastic diets or one-size-fits-all programs. Instead, it’s about building sustainable habits and personalized strategies that work for your life, your preferences, and your metabolism..
        </p>
      </div>

<NutritionSwiper/>

 <div className="reasons-section container mt-5">
                <h3 className="coach">
               Why I Offer Nutrition <br />Coaching
                </h3>
          
                {/* TOP 3 ITEMS */}
                <div className="parent">
                  <div className="reason-box">
                    <div className="check">
                      <FaCheck className="check-mark" />
                    </div>
                    <p className="calistehenic-h">
                   Maximize your results
                    </p>
                    <p className="calistehenic-p">
                    Even the best training won’t reach full potential if your nutrition is misaligned.                   </p>
                  </div>
          
                  <div className="reason-box">
                    <div className="check">
                      <FaCheck className="check-mark" />
                    </div>
                    <p className="calistehenic-h">Sustainable eating patterns</p>
                    <p className="calistehenic-p">
                     I don’t believe in rigid diets. We build habits you can stick with long term.
                    </p>
                  </div>
          
                  <div className="reason-box">
                    <div className="check">
                      <FaCheck className="check-mark" />
                    </div>
                    <p className="calistehenic-h">More strength potential</p>
                    <p className="calistehenic-p">
                     If your body is “locked up,” you can’t access full strength in many movements. Mobility frees you to perform better.
                    </p>
                  </div>
                </div>
          
                {/* BOTTOM 2 ITEMS */}
                <div className="calisthenics mt-4">
                  <div className="reason-box">
                    <div className="check-marks">
                      <FaCheck className="check-mark" />
                    </div>
                    <p className="calistehenic-h">Improve recovery & health</p>
                    <p className="calistehenic-p">
                     Good nutrition supports muscle repair, hormonal balance, sleep, digestion, immunity, and more.
                    </p>
                  </div>
          
                  <div className="reason-box">
                    <div className="check-marks">
                      <FaCheck className="check-mark" />
                    </div>
                    <p className="calistehenic-h">Adaptable for life</p>
                    <p className="calistehenic-p">
                     We’ll adjust as your goals or circumstances change (travel, lifestyle shifts, life stressors).
                    </p>
                  </div>
                </div>
              </div>
                   <Stripes/>


   <div className="nutrition-section">

  <img
    src={bg2}
    alt="Background"
    className="nutrition-bg"
  />

  <div className="nutrition-overlay"></div>

  <div className="nutrition-content container text-center">
    <h2 className="nutrition-title">
      HOW MY NUTRITION <br /> COACHING WORKS
    </h2>

    <p className="nutrition-text">
      <span className="nutrition-bold">Initial nutrition assessment.</span>
      We’ll look at your current eating habits, diet history,
      preferences, possible food sensitivities, and goals.
    </p>

    <p className="nutrition-text">
      <span className="nutrition-bold">Personalized Plan.</span>
      Based on your goals (fat loss, muscle gain, performance) and
      your lifestyle, I’ll design a sustainable nutrition plan.
    </p>

    <p className="nutrition-text">
      <span className="nutrition-bold">Guidance & education.</span>
      You’ll get resources on food choices, portioning, meal prep,
      hunger cues, mindset around food, and strategies for cheat days.
    </p>

    <p className="nutrition-text">
      <span className="nutrition-bold">Ongoing adjustments.</span>
      I’ll tweak your intake and strategy as you progress or hit plateaus.
    </p>

    <p className="nutrition-text">
      <span className="nutrition-bold">Support & accountability.</span>
      Regular check-ins, reflections, and checklists to keep you consistent.
    </p>
  </div>
</div>
<div className="coaching-section">
  <img src={yogahall} alt="Background" className="coaching-bg" />
  <div className="coaching-overlay"></div>

 
<div className="coaching-swiper">
    <VerticalSwiper2 />
  </div>
</div>

  <Signup/>
<Footer/>

</div>
    
       );
};
export default Nutrition;

